import TeacherTimetablePage from "./components/TeacherTimetablePage.vue";

export default {
  routes: [
    {
      path: "/",
      component: TeacherTimetablePage,
      name: "TeacherTimetablePage",
    },
  ],
};
